var map = {
	"./A_rare_silk_nearly_lost_through_war.jpg": 571,
	"./AdefiantmovetotheNorwegianArctic.jpg": 8486,
	"./AhypnoticSwedishtradition.jpg": 4297,
	"./Anationwithoutaccesstoitsownsea.jpg": 2886,
	"./Atinyislewithanunspokenlanguage.jpg": 5804,
	"./CanadasIndigenousfoodrenaissance.jpg": 145,
	"./Canadas_rising_Inuit_TikTok_star.jpg": 8156,
	"./Chileshiddenkingdomoffungi.jpg": 135,
	"./HongKongsguardianofthegods.jpg": 613,
	"./HowriceshapedtheAmericanSouth.jpg": 2054,
	"./IsabelAllendeonfindingjoyinchaos.jpg": 3226,
	"./Kenyasnewfoundlionprotectors.jpg": 5306,
	"./MachuPicchustrailblazingwomen.jpg": 5189,
	"./Malaysiashumblekingofnoodles.jpg": 4703,
	"./New_Zealands_feisty_feathered_patient.jpg": 5749,
	"./Onevillagesdramatictransformation.jpg": 4867,
	"./ScotlandslittleknownHighlanders.jpg": 2825,
	"./Spainsunderwatersuperplant copy.jpg": 3169,
	"./Spainsunderwatersuperplant.jpg": 3675,
	"./SpainsunderwatersuperplantDesktop.jpg": 9564,
	"./TheBahamasqueenofJunkanoo.jpg": 4700,
	"./TheEuropeannationkeepingusyoung.jpg": 1748,
	"./TheRussiantownbuiltbyapples.jpg": 5637,
	"./TheUSremotenorthernoutpost.jpg": 8229,
	"./The_extreme_life_of_Europes_sherpas.jpg": 2480,
	"./TheallureofFrancesMayesItaly.jpg": 2941,
	"./ThechefwhoputSloveniaonthemap.jpg": 8877,
	"./Thecouscousmealthatfeedsgenerosity.jpg": 6583,
	"./Theecologistwhotookontheworld.jpg": 7972,
	"./TheguardianofColoradosFrontRange.jpg": 1501,
	"./Theindigenousrecipeforlivingwell.jpg": 2440,
	"./Themanpreservingendangeredcolours.jpg": 9239,
	"./Theposterboyofzero-wasteliving.jpg": 2062,
	"./ThesacredPolynesianartofwayfinding.jpg": 8246,
	"./Theworldsmostendangeredsound.jpg": 887,
	"./Theworldtravellerwhoneverlefthome.jpg": 2572,
	"./Wherehorsesploughtheseaforfood.jpg": 1679,
	"./Zimbabwesreverednestcustodians.jpg": 460,
	"./thekeepersoftheoutbackssecrets.jpg": 6170,
	"./thenomadguidewhodecodesthesahara.jpg": 7006,
	"./thewomansavingpalestinianfood.jpg": 7157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5959;